import React, { useState , useEffect} from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Fade } from "react-awesome-reveal";
import cIcon1 from '../../images/icon/cp-icon.svg'
import cIcon2 from '../../images/icon/loc-icon.svg'
import cIcon3 from '../../images/icon/clock-icon.svg'
import Loader from "../../components/Loader/Loader";


const jobListings = [
    {
        id: 1,
        job_title: "Enterprise SEO Consultant",
        location: "Remote, (USA)",
        type: "Full time",
        slug: "enterprise-seo-consultant",
        categories: ["cat1", "cat3", "cat5"],
    },
    {
        id: 2,
        job_title: "IT Infrastructure Manager",
        location: "Remote, Colombia",
        type: "Full time",
        slug: "it-infrastructure-manager",
        categories: ["cat2", "cat4"],
    },
    {
        id: 3,
        job_title: "Technical Project Manager",
        location: "Warsaw, Poland",
        type: "Full time",
        slug: "technical-project-manager",
        categories: ["cat1", "cat5"],
    },
    {
        id: 4,
        job_title: "Cloud Solutions Architect",
        location: "Bangalore (Hybrid)",
        type: "Full time",
        slug: "cloud-solutions-architect",
        categories: ["cat2", "cat3"],
    },
    {
        id: 5,
        job_title: "IT Support Engineer",
        location: "Remote, Argentina",
        type: "Full time",
        slug: "it-support-engineer",
        categories: ["cat1", "cat4"],
    },
    {
        id: 6,
        job_title: "Global Benefits Manager",
        location: "Remote, Canada",
        type: "Full time",
        slug: "global-benefits-manager",
        categories: ["cat2", "cat3", "cat5"],
    },
];
var api = "https://script.google.com/macros/s/AKfycbxZiSIlVc5RkpdaqaxGF90hBw3TyZbIjnfzQsmw7zsk11auESgQcFCq82yuHwD8ZrwR/exec";
const CareerTeam = () => {
    const [activeFilter, setActiveFilter] = useState("*");
 

    const [isLoading, setIsLoading] = useState(true);
const [isError, setIsError] = useState(false);
const [jobListingss, setJobListings] = useState([]);

useEffect(() => {
  const fetchApi = async () => {

    const startTime = performance.now();

    try {
      setIsLoading(true);
      setIsError(false);

      // --------------------------------
      // 1. API Request
      // --------------------------------

      const response = await fetch(api);

      const responseReceived =
        performance.now();

      console.log(
        "API network time:",
        `${(responseReceived - startTime).toFixed(2)} ms`
      );

      if (!response.ok) {
        throw new Error(
          `HTTP Error: ${response.status}`
        );
      }


      // --------------------------------
      // 2. JSON Parsing
      // --------------------------------

      const data = await response.json();

      const jsonParsed =
        performance.now();

      console.log(
        "JSON parsing time:",
        `${(jsonParsed - responseReceived).toFixed(2)} ms`
      );


      // --------------------------------
      // 3. Validate API response
      // --------------------------------

      if (
        !data ||
        data.success !== true ||
        !Array.isArray(data.data)
      ) {
        throw new Error(
          "Invalid API response"
        );
      }


      // --------------------------------
      // 4. Check data
      // --------------------------------

      if (data.data.length === 0) {
        setJobListings([]);
        return;
      }


      // --------------------------------
      // 5. Set data
      // --------------------------------

      setJobListings(data.data);


      // --------------------------------
      // 6. Total frontend API time
      // --------------------------------

      const completed =
        performance.now();

      console.log(
        "Total frontend API time:",
        `${(completed - startTime).toFixed(2)} ms`
      );

      console.log(
        "Jobs received:",
        data.data.length
      );


    } catch (error) {

      console.error(
        "Error fetching jobs API:",
        error
      );

      setIsError(true);
      setJobListings([]);

    } finally {

      setIsLoading(false);

    }
  };


  fetchApi();

}, [api]);
//     useEffect(() => {
//       const fetchApi = async () => {
//         //   setLoading(true);
//           try {
//               const response = await fetch(api);
//               if (!response.ok) {
//                 setIsError(true);
//                   return;
//               }
  
//               const data = await response.json();
//               if (!data || data.length === 0) {
//                 setIsError(true);
//                   return;
//               }
           
//               setjobListings(data);
//           } catch (error) {
//               console.error('Error fetching API:', error);
//           } finally{
//             setIsLoading(false);
//           }
//       };
  
//       fetchApi();
//   }, []);
    const handleFilter = (category) => {
        setActiveFilter(category);
    };

    const filters = [
        { key: "*", label: "View All" },
        { key: "cat1", label: "Development" },
        { key: "cat2", label: "Design" },
        { key: "cat3", label: "Marketing" },
        { key: "cat4", label: "Customer Services" },
        { key: "cat5", label: "Management" },
    ];

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <section className="team pt-130 pb-130">
            <div className="container">
                <div className="sec-title--two text-center mb-50">
                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                        <div>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                <img src={cIcon1} alt="icon" />
                                Open Positions
                            </div>
                        </div>
                    </Fade>
                    <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">
                                Join our team
                            </h2>
                        </div>
                    </Fade>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-12 text-center">
                        <div className="team-menu mb-50">
                            {filters.map((filter, index) => (
                                <button
                                    key={index}
                                    className={activeFilter === filter.key ? "active" : ""}
                                    onClick={() => handleFilter(filter.key)}
                                >
                                    {filter.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {isLoading ? (<Loader />) : (isError ? "" : (
                        <div className="col-lg-12">
                        <div className="cp-team-wrap grid">
                            <AnimatePresence>
                                {jobListingss
                                    .filter(
                                        (job) => {
                                            var catgory = JSON.parse(job.categories);
                                          return  activeFilter === "*" || catgory.includes(activeFilter)
                                    }                                    )
                                    .map((job) => {
                                        var catgory = JSON.parse(job.categories);
                                        
                                        return (
                                          <motion.div
                                            key={job.id}
                                            className={`cp-team-item grid-item ${catgory.join(" ")}`}
                                            initial={{ opacity: 0, scale: 0.9 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            exit={{ opacity: 0, scale: 0.9 }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            <div className="xb-item--inner ul_li_between">
                                                <div className="xb-item--content">
                                                    <h3 className="xb-item--title">
                                                        <Link onClick={scrollToTop} to="/career-details">
                                                            {job.job_title}
                                                        </Link>
                                                    </h3>
                                                    <div className="xb-item--holder ul_li">
                                                        <span className="xb-item--meta">
                                                            <img src={cIcon2} alt="location" />
                                                            {job.location}
                                                        </span>
                                                        <span className="xb-item--meta">
                                                            <img src={cIcon3} alt="time" />
                                                            {job.type}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="cp-team-btn">
                                                    <Link onClick={scrollToTop} to={`/career-details/${job.slug}`} className="cp-btn">
                                                        View job <i className="fal fa-arrow-right"></i>
                                                    </Link>
                                                </div>
                                            </div>
                                        </motion.div>  
                                        )
                                        
})}
                            </AnimatePresence>
                        </div>
                    </div>))} 
                </div>
            </div>
        </section>
    );
};

export default CareerTeam;
